var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"list-group-item list-group-item-action",class:_vm.styling,attrs:{"href":"#","aria-current":_vm.ariaStatus},on:{"click":_vm.handleSelect}},[_c('i',{staticClass:"bi-book",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{class:_vm.textStyling},[_vm._v("Instructions")])])
}
var staticRenderFns = []

export { render, staticRenderFns }